import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import Image from '@jetshop/ui/Image/Image';
import ReadMore from '../Util/ReadMore';
import { SubCategories } from './SubCategories';
import { BreadcrumbsWrapper } from '../Layout/BreadcrumbsWrapper';
import { theme } from '../Theming/Theming';
import { ContentRender } from '../ContentRender/ContentRender';
import TextContent from '../ui/TextContent';
import { config } from '../../shop.config.custom';
import { SubCategoriesGrid } from './SubCategoriesGrid';
import BackArrow from '../ui/BackArrow';

const CategoryImageWrapper = styled('div')`
  ${theme.below.md} {
    [data-flight-image-container] {
      padding-bottom: 25% !important;
    }
  }
`;

const CategoryName = styled('h1')`
  position: relative;
  display: flex;
  align-items: center;
`;

const CategoryTextWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  .breadcrumbs-wrapper {
    padding: 0.7rem 0 0.5rem;
    margin: 0;
  }
  .breadcrumbs-wrapper ul {
    justify-content: center;
  }
  .subcategories-list {
    margin: 0 auto;
  }
  .category-description,
  .category-name {
    width: 100%;
    margin: 0 auto;
  }
  .page-header-wrapper {
    position: relative;
    .back-arrow {
      position: absolute;
      left: 0;
    }
  }
  ${CategoryName} {
    justify-content: center;
    &.only-name {
      text-align: left;
    }
    ${theme.only.lg} {
      font-size: ${theme.typography.header.fontSize[2][2]};
    }
    ${theme.above.lg} {
      //margin-bottom: 0.5em;
    }
  }
  &.standard {
    .inner-content > div > *:first-child {
      margin-top: 0;
    }
    ${theme.above.lg} {
      padding: 0 1rem;
    }
    .read-more-button {
      ${theme.below.lg} {
        padding: 0;
      }
    }
    .category-description,
    .category-name {
      max-width: 800px;
    }
  }
  &:not(.standard) {
    margin: 0 auto 4rem;
    max-width: ${theme.general.maxWidthText};
  }
  padding: 0 ${theme.general.pagePadding.sm};
`;

const CategoryDescription = styled('div')`
  padding-bottom: 0.5rem;
`;

const CategoryHeaderWrapper = styled('header')`
  ${theme.below.md} {
    margin-bottom: 1rem;
  }
  ${theme.above.lg} {
    &:not(.has-image) {
      margin-bottom: 1rem;
      &.standard {
        ${CategoryTextWrapper} {
          text-align: center;
        }
      }
    }
    &.standard.has-image {
      ${CategoryImageWrapper} {
      }
      ${CategoryTextWrapper} {
        ${theme.above.lg} {
          padding: 0 3rem;
        }
        .breadcrumbs-wrapper {
        }
      }
    }
  }
`;

const StyledContentRender = styled(ContentRender)`
  margin-bottom: 1%;
`;

const CategoryHeader = ({
  category,
  breadcrumbProps = false,
  standardCategory = true,
  showSubs = true,
  showText = false
}) => {
  const hasImage = category.images && category.images.length > 0;
  const showGrid = config.routes.brand.id === category.id;
  const brandArea = config.routes.brand.id === category.parentId;
  return (
    <>
      <CategoryHeaderWrapper
        className={cx(standardCategory && 'standard', hasImage && 'has-image')}
      >
        {hasImage ? (
          <CategoryImageWrapper className={`category-image-wrapper`}>
            <Image
              critical={true}
              aspect={'6:1'}
              crop={true}
              src={category.images[4].url}
              sizes={[1]}
              cover={true}
              quality={80}
            />
          </CategoryImageWrapper>
        ) : null}
        <CategoryTextWrapper
          className={`category-text-wrapper ${
            standardCategory ? 'standard' : ''
          }`}
        >
          {breadcrumbProps && <BreadcrumbsWrapper {...breadcrumbProps} />}
          <div className="page-header-wrapper">
            <BackArrow parents={breadcrumbProps.parents} />
            <CategoryName data-testid="page-header" className="category-name">
              {category.mainHeader ? category.mainHeader : category.name}
            </CategoryName>
          </div>
          {category.content && showText && (
            <CategoryDescription
              className={`category-description content-area ${
                standardCategory ? 'standard' : ''
              }`}
              data-testid="category-description"
            >
              {standardCategory ? (
                <ReadMore breakPoint={150} maxHeight={100} icon={true}>
                  <TextContent content={category.content} />
                </ReadMore>
              ) : (
                <TextContent content={category.content} />
              )}
            </CategoryDescription>
          )}
          {!showGrid && showSubs && (
            <SubCategories
              category={category}
              parents={breadcrumbProps.parents}
              noSiblings={brandArea}
            />
          )}
          {showGrid && <SubCategoriesGrid category={category} />}
        </CategoryTextWrapper>
      </CategoryHeaderWrapper>
      <StyledContentRender data={category.data} />
    </>
  );
};

export default CategoryHeader;
